import { useCallback, useMemo } from 'react'
import { useAiChat } from '@factorialco/f0-react'

import { useActivity } from 'modules/core/lib/activities/activity'
import type { ActivityComponent } from 'modules/core/lib/activities/types'
import i18n from 'modules/core/lib/i18n'
import { CreateTicketDialog } from 'modules/ticketing/components/CreateTicketDialog'

type Data = {
  title?: string
  description?: string
  categoryId?: string
  categoryName?: string
  priority?: string
}

export const CreateTicketActivity: ActivityComponent<Data> = ({
  title,
  description,
  categoryId,
  categoryName,
  priority,
}) => {
  const { open, closeActivity } = useActivity()
  const aiChat = useAiChat()
  const initialValues = useMemo(
    () => ({ title, description, categoryId, categoryName, priority }),
    [categoryId, categoryName, description, priority, title]
  )

  const handleLaunchAiTicketCreation = useCallback(
    (message: string, options?: { source?: 'description' | 'category' }) => {
      const trimmedMessage = message.trim()
      if (!trimmedMessage) return

      const ticketingPrompt =
        options?.source === 'category'
          ? trimmedMessage
          : `${i18n.t('ticketing.inbox.create.ai_description_message_prefix')} ${trimmedMessage}`
      aiChat.clear()
      aiChat.setVisualizationMode('fullscreen')
      aiChat.setOpen(true)
      closeActivity()

      window.setTimeout(() => {
        aiChat.sendMessage(ticketingPrompt)
      }, 0)
    },
    [aiChat, closeActivity]
  )

  return (
    <CreateTicketDialog
      isOpen={open}
      onClose={closeActivity}
      initialValues={initialValues}
      onLaunchAiTicketCreation={handleLaunchAiTicketCreation}
    />
  )
}
